import axios from "axios";
import store from "../../components/Stores/SurveyStore"
import userStore from "../../components/Stores/UserStore"
import {
    safeJsonParse,
    setActualCommentValue,
    setActualErrorCommentValue,
    setTempAnalystCommentValue
} from "../../helpers"
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {saveAs as importedSaveAs} from 'file-saver';
import sharedStore from "../../components/Stores/SharedStore";
import numeral from "numeral";
import {getCookie} from "../Authentication/AuthHelper";
import { InputState, PABS_SURVEY_MAP, SurveyTypeURL } from "../../Enums/constants";
import {runInAction} from "mobx";

//get account related info
export async function getAccountInfo() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }   
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/getAccountInfoNew", config)
        .then(response => {
            userStore.accountInfo = response.data;
        })
        .catch(error => {
            console.error(error);
        });
}

//get account related info
export async function getAvailablePlansPabs() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }   
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/getAvailablePlans", config)
        .then(response => {
            let resp = safeJsonParse(response.data, [])
            runInAction(() => {
                store.availableUserPlanRoles = resp
                const uniquePlanIdMap = [...new Set(resp.map(item => item.PlanId))];
                const uniquePlans = uniquePlanIdMap.map(planId => resp.find(item => item.PlanId === planId));
                store.availablePlanProducts = uniquePlans;
            })
        })
        .catch(error => {
            console.error(error);
        });
}

export function checkIfAnalyst() {
    let oidcTokenNew = localStorage.getItem("oidc.user:https://identity.cembenchmarking.com/core/:" + sharedStore.identityConfig.clientId)
    let idp = JSON.parse(oidcTokenNew)?.profile.idp;
    if (idp == "CEM.EmployeeIdentityAdfs") { //CEM.EmployeeIdentityAdfs
        //is an analyst
        return true
    }

    return false
}

/**
 * Get all available surveys available to the user's organization for easy access to previous years' data
 * */
export async function getAvailableSurveys(orgIdRequest) {

    const config = {
        headers : {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, 
        params: {
            orgId: orgIdRequest
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/getAvailableSurveys", config)
        .then(response => {
            store.availableSurveys = safeJsonParse(response.data, []);
        })
        .catch(error => {
            console.error(error);
        });
}

export async function getAvailableSurveysForAllPABSPlans(planIdRequestRaw) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            orgId: planIdRequestRaw
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/getAvailableSurveys", config)
        .then(response => {
            const responseData = safeJsonParse(response.data, []);
            runInAction(() => {
                responseData.forEach(element => {
                    store.allAvailableSurveys.push(element)
                })
            })
        })
        .catch(error => {
            console.error(error);
        });
}


export async function setLastWorkedOnOrg(orgId) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .post(`${sharedStore.identityConfig.clientRoot}api/PabsSurvey/LastWorkedOnOrg/${orgId}`, null, config)
        .then(response => {
          
        })
        .catch(error => {
            console.error(error);
        });
}

export async function SetCultureFromSurvey() {
    const surveyId = store.currentSurvey.SurveyId;
    
    const config = {
        headers : {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/CultureIdentifier", config)
        .then(response => {
            sharedStore.cultureIdentifier = safeJsonParse(response.data, [])
            numeral.locale(sharedStore.cultureIdentifier)
        })
        .catch(error => {
            console.error(error);
        });
}

export function pabsUrlVerification() {

    if (!Number.isInteger(store.currentSurvey?.SurveyTypeId)) {
        return;
    }
    const currentSurveyTypeEnum = PABS_SURVEY_MAP[store.currentSurvey?.SurveyTypeId];

    if (currentSurveyTypeEnum == null) {
        return;
    }
    const expectedCurrentURL = SurveyTypeURL[currentSurveyTypeEnum.type];
    if (expectedCurrentURL != null && !window.location.href.toLowerCase().includes(expectedCurrentURL)) {
        window.location.replace(expectedCurrentURL);
    }
}

export async function setCurrentSurvey(orgId, surveyId = 0) {

    store.loadingSurvey = true;
    await getAvailableSurveys(orgId);

    store.currentSurvey = store.availableSurveys.find(survey => survey["SurveyId"] === surveyId);

    if (typeof store.currentSurvey?.SurveyId === "number" && !isNaN(store.currentSurvey?.SurveyId)) {
        if (typeof store.currentSurvey?.DataYear === "number" && !isNaN(store.currentSurvey?.DataYear)){
          store.currentYear = store.currentSurvey?.DataYear;
        } else {
          store.currentYear = null; // Reset to default value to avoid stale data
        }
    }

    // Reminder that for V3, we should never try to do local storage caching 
    localStorage.setItem('selectedPabsSurveyId', store.currentSurvey.SurveyId);
    localStorage.setItem('selectedPabsSystemId', store.currentSurvey.SystemId);
    localStorage.setItem('selectedPabsDataYear', store.currentYear);

    pabsUrlVerification();
    
    await Promise.all([
        GetResponsesForAllPages(),
        SetCultureFromSurvey(),
        getAllSurveyErrors(),
        getSurveyErrorsSummary(),
    ])
    
    store.loadingSurvey = false;
}


/**
 * This requests for a list of all surveys that analysts will be able to browse and access 
 * */
export async function getPabsSurveyList() {
    const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + getCookie("access_token")
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetPabsSurveysList", { headers })
        .then(response => {
            const surveyList = safeJsonParse(response.data, []);
            runInAction(() => {
                store.pabsSurveysList = surveyList;
                store.surveyListDisplay = surveyList;//hmmmm  clean this up 
            })
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * This request saves the new value into the database for a changed input (numinput, textinput, select etc) and will update the error list in the store for real time feedback (if possible)
 * @param {any} inputName The name of the input that was changed
 * @param {any} value The value that the user has provided for that input
 * @param {any} inputStateId Only affects number input, this id determines whether the value is normal, Na, or Unknown
 */
export function saveInputValuePABS(inputName, value, inputStateId = InputState.NOT_SET) {
    var surveyId = store.currentSurvey.SurveyId;
    var page = store.currentLandedPage;
   
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            questionName: inputName,
            value: value,
            page: page,
            surveyId: surveyId,
            inputState: inputStateId ?? InputState.NOT_SET
        },
    };

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/Save", config)
        .then(response => {
            setTempAnalystCommentValue(""); // TODO What's this for?
            if (!store.allValidationErrorsList[store.currentLandedPage]){
                store.allValidationErrorsList[store.currentLandedPage] = [];
            }
            if (store.allValidationErrorsList[store.currentLandedPage] && store.allValidationErrorsList[store.currentLandedPage].length > 0) {
                var index = store.allValidationErrorsList[store.currentLandedPage].findIndex(obj => {
                    return obj.QuestionName.toLowerCase() == inputName.toLowerCase();
                })
            }

            //if there was an error on this input previously, remove it since the survey will need to be revalidated to redetermine the error status of that input 
            if (index >= 0) {
                store.allValidationErrorsList[store.currentLandedPage].splice(index, 1)

            }

            //add to error list if a error is returned, ie error message exists
            var error = safeJsonParse(response.data, { list: [] }).list[0];
            if (error && error.ErrorMessage !== null) {

                store.allValidationErrorsList[store.currentLandedPage].push({ "ErrorMessage": error.ErrorMessage, "ErrorTypeID": error.ErrorTypeID, "QuestionName": error.QuestionName })
            }
        })
        .catch(error => {
            console.error(error);
            
            toast("Error saving.  Please refresh the page and try again.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 4000,
                hideProgressBar: true,
                className: "red-notif"
            });
            store.databaseConnection = false;
        })
}

/**
 * This request saves the comment for a given question provided by an analyst into the database
 * @param {any} qname The name of the question for which an explanation was given
 * @param {any} commentAdded The comment that the user has provided
 */
export function AddAnalystComments(qname, commentAdded) {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            questionName: qname,
            comments: commentAdded,
            surveyId: surveyId
        },

    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/AddAnalystComments", config)
        .then(response => {
            setActualCommentValue()
            if (commentAdded) {
                toast("Comment sucessfully updated.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    draggable: false,
                    autoClose: 4000,
                    hideProgressBar: true,
                    className: "success-notif"

                });
            }

        })
        .catch(error => {
            console.error(error);
            toast("Error: The comment was unable to be updated.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 4000,
                hideProgressBar: true,
                className: "red-notif"

            });
        });
}

/**
 * This request saves the error explanation for a given question provided by an analyst into the database
 * @param {any} qname The name of the question for which an explanation was given
 * @param {any} errorExplanation The explanation that the user has provided
 */
export function AddErrorComments(qname, errorExplanation) {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            questionName: qname,
            comments: errorExplanation,
            surveyId: surveyId
        },

    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/AddCommentsToError", config)
        .then(response => {
            runInAction(() => {
                setActualErrorCommentValue()
            })
        })
        .catch(error => {
            console.error(error);
        });
}

export function submitSurvey() {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        }
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/Submit", config)
        .then(response => {
            store.currentSurvey.IsReadOnly = true;
            //assumes user has submit tab
           //add unlock tab 


        })
        .catch(error => {
            console.error(error);
        });

}

/**
 * This function requests an error list for the currently landed page. If the error list contains new data compared to the error list in the store, then update store
 * @param {any} page The current page the user is on
 * @param {any} lang The language (default: en)
 */
export async function getPageErrors(page) {
    var surveyId = store.currentSurvey.SurveyId;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            page: page,
            surveyId: surveyId,
        },

    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/UpdatePreloadPageError", config)
        .then(response => {
            store.allValidationErrorsList[page] = safeJsonParse(response.data, []);
        })
        .catch(error => {
            console.error(error, page);
        });
   
}

/**
 * This requests to get all the errors for all pages of the survey. Should only be happening once per load up of survey.
 * */
export async function getAllSurveyErrors() {
    const surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        },
    }
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetAllPageErrors", config)
        .then(response => {
            const parsed = safeJsonParse(response.data, {});
            store.allValidationErrorsList = Object.keys(parsed).reduce((acc, key) => {
                acc[key.toLowerCase()] = parsed[key];
                return acc;
            }, {});
        })
        .catch(error => {
            console.error('getAllSurveyErrors', error);
        });
}

/**
 * This requests for a summary of all errors in the survey. Returns a list with a count of warnings and errors per page.  
 * @param {any} lang The language
 */
export async function getSurveyErrorsSummary() {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
        },
    };
    await axios
        .get("/api/PabsSurvey/GetPreLoadErrorsSummary", config)
        .then(response => {
            runInAction(() => {
                store.currentSurvey.IsValidated = response.data.IsValidated;
                store.surveyAllErrors = safeJsonParse(response.data, { list: [] }).list;
                store.loadingErrorSummaryDone = true;
            })
        })
        .catch(error => {
            console.error(error);
        });

}
export async function getHelpFilePabs() {
    let countryID = store.currentSurvey.CountryID;
    const config = {
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            countryId: countryID
        }
    };

    await axios
        .get("/api/PabsSurvey/getHelpFile", config)
        .then(response => {
            const contentType = response.headers["content-type"].trim();
            const returnedFileName = `CEM_Pabs_Cost_Instructions.pdf`;

            const blob = new Blob([response.data], { type: contentType });

            importedSaveAs(blob, returnedFileName);
        })
        .catch(error => {
            console.error(error);
        });

}

export async function getActivityDefsFilePabs() {
  let countryID = store.currentSurvey.CountryID;
  const config = {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + getCookie("access_token")
    },
    params: {
      countryId: countryID
    }
  };

  await axios
    .get("/api/PabsSurvey/getActivityDefsFile", config)
    .then(response => {
      const contentType = response.headers["content-type"].trim();
      const returnedFileName = `CEM_Pabs_Activity_Definitions.pdf`;

      const blob = new Blob([response.data], { type: contentType });

      importedSaveAs(blob, returnedFileName);
    })
    .catch(error => {
      console.error(error);
    });
}


export async function getExcelTemplatePabs() {
    const config = {
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: store.currentSurvey.SurveyId,
        }
    };
    axios
        .get("/api/PabsSurvey/getExcelTemplate", config,)
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            importedSaveAs(blob, "CEM Survey.xlsx");
        })
        .catch(error => {
            console.error(error);
        });
}
/**
 * This function does a validation for users and saves all errors into the database
 */
export function validateSurvey() {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, 
        params: {
            surveyId: surveyId, 
        }
    };
    axios
        .get("/api/PabsSurvey/ValidateSurvey", config)
        .then(response => {
            runInAction(() => {
                store.currentSurvey.IsValidated = true;
                store.loadingErrorSummaryDone = true;
            })
            
            //should we request all survey errors again??
            getAllSurveyErrors()
            getSurveyErrorsSummary()
        })
        .catch(error => {
            console.error(error);
        });

}
/**
 * This function does a validation for admin users (ie analysts) and saves all errors into the database
 * @param {any} page The current page the user requested to validate from -so that real time error updates can be given after validation
 * @param {any} lang The language
 */
export function validateAdminOnly(lang) {
    var surveyId = store.currentSurvey.SurveyId;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId
        }
    };
    axios
        .get("/api/PabsSurvey/ValidateAdminOnly", config)
        .then(response => {
            //get page's errors to rerender
            //getPageErrorsCtrl(lang) //something wrong here?? page is not right when using param
            getAllSurveyErrors()
            getSurveyErrorsSummary()
            toast("The survey has been validated in admin mode.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 7000,
                hideProgressBar: true,
                className: "info-notif"
            });
        })
        .catch(error => {
            console.error(error);

        });
}

/**
 * Change the visible survey to the one chosen by user 
 * @param {any} surveyId
 */
export async function changeSurvey(surveyId, orgId) {
    if (orgId !== store.currentSurvey.SystemId) {
        await getAvailableSurveys(orgId);
        await setLastWorkedOnOrg(orgId);
    }
    await setCurrentSurvey(orgId, surveyId);
}

export async function GetResponsesForAllPages() {
    const surveyId = store.currentSurvey.SurveyId;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        },
    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetAllResponsesByPage", config)
        .then(response => {
            const responsesByPageName = safeJsonParse(response.data, {});
            runInAction(() => {
                store.clearAllPageResponses();
                for (const pageName of Object.keys(responsesByPageName)) {
                    const responses = responsesByPageName[pageName];
                    if (Array.isArray(responses)) {
                        store.allPageResponses[pageName.toLowerCase()] = responses;
                        if (!store.allPageResponses["combined"]) {
                            store.allPageResponses["combined"] = [];
                        }
                        store.allPageResponses["combined"].push(...responses);
                    } else {
                        console.warn(`Unexpected data type page ${pageName}:`, responses);
                    }
                }
            });
        })
        .catch(error => {
            store.databaseConnection = false;
            console.error(error);
        })
}

export function getPreviousYearValue(questionName) {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            questionName: questionName,
            surveyId: surveyId,
        },

    };

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetLySurveyResponse", config)
        .then(response => {
            if (response.data) {
                store.previousYearValue = response.data;
            } else {
                store.previousYearValue = "blank"
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.error(error);
        });

}

export function getPreviousYearValueForPanel(questionName) {
    var surveyId = store.currentSurvey.SurveyId;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            questionName: questionName,
            surveyId: surveyId,
        },
    };

    store.prevYearPanel.loading = true;

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetLySurveyResponse", config)
        .then(response => {
            store.prevYearPanel.value = response.data != null ? response.data : "blank";
            store.prevYearPanel.loading = false;
        })
        .catch(error => {
            store.prevYearPanel.loading = false;
            store.databaseConnection = false;
            console.error(error);
        });
}

export function unlockSurvey() {
    var surveyId = store.currentSurvey.SurveyId
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/Unlock", config)
        .then(response => {
            store.currentSurvey.IsReadOnly = false;
        })
        .catch(error => {
            console.error(error);
        });

}

/**
 * Data for Your Results Tab
 * @returns {Promise<void>}
 */
export async function getYourBenchmarkSummaryData() {
    let surveyId = store.currentSurvey.SurveyId;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        }

    };
    await axios
        .get("/api/PabsSurvey/GetYourBenchmarkSummary", config)
        .then(response => {
            store.yourBenchmarkSummary = response.data;
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Requests for cost data used in the sample results
 * */
export async function changeSurveyCleaner(surveyId, userId) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            //systemId: systemId,
            //surveyTypeId: surveyTypeId
            surveyId: surveyId,
            surveyCleanerID: userId
        }

    };
    await axios
        .get("/api/PabsSurvey/SaveSurveyCleaner", config)
        .then(response => {
            toast.success("Survey cleaner updated successfully");
        })
        .catch(error => {
            console.error('Save survey cleaner error:', error);
            toast.error("Failed to update survey cleaner");
        });
}

export async function changeSurveyStatus(surveyId, statusTypeId) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
            surveyStatusTypeId: statusTypeId
        }
    };
    await axios
        .get("/api/PabsSurvey/SaveSurveyStatus", config)
        .then(response => {
            toast.success("Survey status updated successfully");
        })
        .catch(error => {
            console.error('Save survey status error:', error);
            toast.error("Failed to update survey status");
        });
}

export async function getPabsLaundryList() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetLaundryList", config)
        .then(response => {
            store.pabsSurveysList = response.data;
        })
        .catch(error => {
            console.error('PABS laundromat API error:', error);
            toast.error("Failed to load PABS laundromat data");
        });
}

export async function getPabsSurveyStatusTypes() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/GetSurveyStatusTypes", config)
        .then(response => {
            store.pabsSurveyStatusTypes = response.data;
        })
        .catch(error => {
            console.error('PABS status types API error:', error);
            toast.error("Failed to load PABS status types");
        });
}

export async function saveQuestionsSentDate(surveyId, questionsSentDate) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            questionsSentDate: questionsSentDate
        }
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PabsSurvey/SaveQuestionsSentDate", config)
        .then(response => {
            toast.success("Questions sent date saved successfully");
        })
        .catch(error => {
            console.error('Save questions sent date error:', error);
            toast.error("Failed to save questions sent date");
        });
}

